import React from 'react'
import { Line } from 'react-chartjs-2'
import moment from 'moment'
import {
  chartjsDefaultArguments,
  chartjsDefaultOptions,
  chartjsScaleLabelProperties,
  chartjsTitleProperties,
  momentTimeFormat
} from '../../../common/Constants'

const StackedLineChart = (props) => {
  const data = {
    labels: props.labels,
    datasets: Array.from(props.datasets).map(serie => ({ ...serie, data: serie.data.map(value => value == null ? null : Number(value)) }))
  }

  const options = {
    ...chartjsDefaultOptions,
    plugins: {
      title: {
        text: props.title,
        ...chartjsTitleProperties
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || ''
            if (label) label += ': '
            label += moment(context.parsed.y).utc().format(momentTimeFormat)
            return label
          }
        }
      }
    },
    scales: {
      x: {
        ticks: {
          font: { size: 17.5 }
        }
      },
      y: {
        min: 18 * 3600 * 1000,
        ticks: {
          source: 'auto',
          maxTicksLimit: 11,
          stepSize: 60,
          callback: (_value, index, ticks) => {
            return moment(ticks[index].value).utc().format(momentTimeFormat)
          }
        },
        type: 'time',
        time: {
          parser: value => { return moment(Number(value)).utc() },
          unit: 'minute',
          displayFormats: {
            minute: momentTimeFormat
          }
        },
        title: {
          text: props.yLabel,
          ...chartjsScaleLabelProperties
        }
      }
    }
  }
  return (
    <div className='chartjs-container'>
      <Line {...chartjsDefaultArguments} data={data} options={options} redraw />
    </div>
  )
}

export default StackedLineChart
